import * as yup from 'yup';
import { QuizCallout } from '@web/components';
import { requiredImageFromCMSSchema } from '../schemas';

export const component = QuizCallout;

export const schema = yup
  .object({
    headline: yup.string(),
    subheadline: yup.string(),
    attribute: yup.string(),
    icon: requiredImageFromCMSSchema,
    fontColor: yup.string(),
    backgroundColor: yup.string(),
  })
  .transform(value => {
    if (!value) return value;
    return {
      headline: value.headline,
      subheadline: value.subheadline,
      attribute: value.attribute,
      icon: value.icon,
      fontColor: value.font_color || undefined,
      backgroundColor: value.background_color || undefined,
    };
  });
